import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { FollowsRetroplannings } from '@app/models';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class RetroplanningService {
  constructor(private http: HttpClient) {}

  get() {
    return this.http.get(`${API}retroplanning`);
  }

  getOne(id) {
    return this.http.get(`${API}retroplanning/${id}`);
  }

  update(followId: number, data: any) {
    return this.http.put(`${API}retroplanning/${followId}/${data.id}`, data);
  }

  delete(idRetroplanning: number, followId: number) {
    return this.http.put(
      `${API}retroplanning/${followId}/delete/${idRetroplanning}`,
      { idRetroplanning: idRetroplanning }
    );
  }

  create(FollowId: number, retroplanning: FollowsRetroplannings) {
    return this.http.post(`${API}retroplanning/${FollowId}`, retroplanning);
  }
}
